<!-- 				-->
<!-- Confirm Dialog -->
<!-- 				-->
<p-confirmDialog [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!-- 				 -->
<!-- School Selector -->
<!-- 				 -->
<div class="selector-body">
	<div class="selector-item">
		<div>
			<label>School</label>
		</div>

		<div style="margin-left: 10px">
			<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
			<!-- <select class="form-control" name="SchoolSelector" style="font-size:smaller;"
				[(ngModel)]="SelectedSchool"
				(ngModelChange)="onSchoolChange($event)">
				<option *ngFor="let r of lstSchool" [ngValue]="r">{{r.SchoolNumber}} - {{r.SchoolName}}</option>
			</select> -->

			<caass-schoolselector [ShowAll]="SchoolSelectShowAll" [ShowAllID]="SchoolSelectShowAllID" [ShowAllText]="SchoolSelectShowAllText">
			</caass-schoolselector>
		</div>

		<!-- 				   -->
		<!-- Display When Busy -->
		<!-- 				   -->
		<div style="margin-left: 20px" [style.display]="isBusy == true ? 'block' : 'none'">
			<img class="busy-img" src="assets/images/loading.gif" />
		</div>

		<div style="margin-left: 20px" [style.display]="isBusy == false ? 'block' : 'none'">
			<label>Download Requests Left:</label>
			<label>{{ SchoolDownloadRequests }}</label>
		</div>

		<div *ngIf="IsSU() == true && isBusy == false" style="margin-left: 20px">
			<button class="btn btn-success" (click)="onResetDonwloadRequests()">Reset for This School (SU Only)</button>
		</div>
	</div>
</div>

<!-- 		 -->
<!-- Buttons -->
<!-- 		 -->
<div class="download-body">
	<div>
		<label class="download-body-header">Export Student Photos</label>
	</div>

	<!-- 					   -->
	<!-- StudentGroup Selector -->
	<!-- 					   -->
	<div class="studentgroup-selector">
		<div>
			<label>Group</label>
		</div>

		<div style="margin-left: 10px; width: 250px">
			<!-- Note: (ngModelChange) must go after [(ngModel)] or you get prev selected item!  -->
			<select
				class="form-control"
				name="StudentGroupSelector"
				style="font-size: smaller"
				[(ngModel)]="SelectedStudentGroup"
				(ngModelChange)="onStudentGroupChange($event)"
			>
				<option *ngFor="let r of lstStudentGroup" [ngValue]="r">
					{{ r.GroupName }}
				</option>
			</select>
		</div>
	</div>

	<div class="download-btn-body">
		<button
			class="btn btn-primary button-center"
			(click)="onExportStudentPhoto()"
			[disabled]="isStudentDownloadBusy == true || isStaffDownloadBusy == true"
		>
			Download
		</button>
		<button
			class="btn btn-primary button-center"
			style="margin-left: 10px"
			(click)="onExportStudentMap()"
			[disabled]="isStudentDownloadBusy == true || isStaffDownloadBusy == true"
		>
			Export File Names
		</button>

		<!-- 				   -->
		<!-- Display When Busy -->
		<!-- 				   -->
		<div style="margin-left: 20px" [style.display]="isStudentDownloadBusy == true ? 'block' : 'none'">
			<img class="busy-img" src="assets/images/loading.gif" />
		</div>
	</div>
</div>

<div class="download-body">
	<div>
		<label class="download-body-header">Export Staff Photos</label>
	</div>

	<div class="download-btn-body">
		<button class="btn btn-primary button-center" (click)="onExportStaffPhoto()" [disabled]="isStudentDownloadBusy == true || isStaffDownloadBusy == true">
			Download
		</button>
		<button
			class="btn btn-primary button-center"
			style="margin-left: 10px"
			(click)="onExportStaffMap()"
			[disabled]="isStudentDownloadBusy == true || isStaffDownloadBusy == true"
		>
			Export File Names
		</button>

		<!-- 				   -->
		<!-- Display When Busy -->
		<!-- 				   -->
		<div style="margin-left: 20px" [style.display]="isStaffDownloadBusy == true ? 'block' : 'none'">
			<img class="busy-img" src="assets/images/loading.gif" />
		</div>
	</div>
</div>

<div style="margin-top: 20px"></div>
<!-- Spacer -->

<!--   			     -->
<!-- Student Message -->
<!-- 			     -->
<div class="message-student" [style.display]="StudentMessage != '' ? 'block' : 'none'">
	<label>{{ StudentMessage }}</label>
</div>

<!--   			   -->
<!-- Staff Message -->
<!-- 			   -->
<div class="message-student" [style.display]="StaffMessage != '' ? 'block' : 'none'">
	<label>{{ StaffMessage }}</label>
</div>
